import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout/components/content/ContentRoute";
import AwaitedFactorSales from "../sale/factor/awaitedFactorSales";

export default function CartableConfigPage() {
  return (
    <Switch>
      {
        <Redirect
          exact={true}
          from="/cartable"
          to="/cartable/AwaitedFactorSales"
        />
      }
      <ContentRoute
        path="/cartable/AwaitedFactorSales"
        component={AwaitedFactorSales}
        label={undefined}
        children={undefined}
        render={undefined}
      />
    </Switch>
  );
}
